import { request } from './client';
import type { ApprovalInput, ApprovalResult, FreeIssueInput, FreeIssueResult, PendingApproval, ShipmentIssueInput, ShipmentIssueResult, ShipmentPending } from '@kassa/shared';

export interface IssuedShipment {
  id: string;
  displayNo: string;
  customerName: string;
  date: string;
  qty: number;
}

export interface ShipmentWarehouse {
  id: string;
  name: string;
  outletName: string;
  twoStep: boolean;
}

export const shipmentsApi = {
  shipmentsIssued: () => request<IssuedShipment[]>('GET', '/api/shipments/issued'),
  shipmentWarehouses: () => request<ShipmentWarehouse[]>('GET', '/api/shipments/warehouses'),
  shipmentSetTwoStep: (warehouseId: string, enabled: boolean) =>
    request<{ id: string; twoStep: boolean }>('POST', `/api/shipments/warehouses/${encodeURIComponent(warehouseId)}/two-step`, { enabled }),
  shipmentCancel: (verId: string, id: string) =>
    request<{ id: string; displayNo: string; duplicate: boolean }>('POST', `/api/shipments/issues/${encodeURIComponent(verId)}/cancel`, { id }),
  shipmentsPending: () => request<ShipmentPending[]>('GET', '/api/shipments/pending'),
  shipmentIssue: (saleId: string, body: ShipmentIssueInput) =>
    request<ShipmentIssueResult>('POST', `/api/shipments/${encodeURIComponent(saleId)}/issue`, body),
  freeIssue: (body: FreeIssueInput) => request<FreeIssueResult>('POST', '/api/shipments/free-issue', body),
  approvalsPending: () => request<PendingApproval[]>('GET', '/api/shipments/pending-approval'),
  approve: (verId: string, body: ApprovalInput) =>
    request<ApprovalResult>('POST', `/api/shipments/issues/${encodeURIComponent(verId)}/approve`, body),
};
